import React from "react";
import { Check } from "lucide-react";
import { STATUS_LABELS } from "@/lib/constants";

export default function StatusStepper({ statuses, current, accent = "primary" }) {
  const idx = statuses.indexOf(current);
  const activeColor = accent === "accent" ? "bg-accent" : "bg-primary";
  const textColor = accent === "accent" ? "text-accent" : "text-primary";
  return (
    <div className="flex flex-col gap-1" data-testid="status-stepper">
      {statuses.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        return (
          <div key={s} className="flex items-center gap-3">
            <div className="flex flex-col items-center">
              <div
                className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center border-2 transition-colors
                  ${done ? `${activeColor} border-transparent text-white` : active ? `${activeColor} border-transparent text-white animate-pulse` : "bg-muted border-border text-muted-foreground"}`}
              >
                {done ? <Check className="w-4 h-4" /> : <span className="text-xs font-bold">{i + 1}</span>}
              </div>
              {i < statuses.length - 1 && (
                <div className={`w-0.5 h-6 ${i < idx ? activeColor : "bg-border"}`} />
              )}
            </div>
            <span className={`text-sm ${active ? `font-bold ${textColor}` : done ? "text-foreground" : "text-muted-foreground"}`}>
              {STATUS_LABELS[s]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
